import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { INeighborhoodEmployeesConnectionWithTotal } from '@api/types'
import { NeighborhoodEmployees } from '@api/fragments'

interface Payload {
  data: {
    node: INeighborhoodEmployeesConnectionWithTotal
  }
}

export const neighborhoodEmployeesQuery = gql`
  query NeighborhoodEmployees($id: ID!, $where: EmployeeWhereInput, $first: Int, $after: String) {
    node(id: $id) {
      ... on Neighborhood {
        ...NeighborhoodEmployees
      }
    }
  }
  ${NeighborhoodEmployees}
`

export default function employees({
  id,
  first = 5,
  query = '',
  after = '',
}: {
  id: string
  first?: number
  query?: string
  after?: string
}): Promise<INeighborhoodEmployeesConnectionWithTotal> {
  return client.gql
    .query({
      query: neighborhoodEmployeesQuery,
      variables: {
        id,
        first,
        where: {
          OR: [{ name_contains: query }, { email_contains: query }],
        },
        after,
      },
    })
    .then(({ data: { node } }: Payload) => node)
}
